export const validateEmail = (inputText: any) => {
  const mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  if (inputText.match(mailFormat)) {
    return true;
  } else {
    return false;
  }
};

export const validateZipCode = (inputText: any, len: any) => {
  if (len == 6) {
    var Zip = /^\d{6}/;
    if (inputText.match(Zip) && inputText.length == len) {
      return true;
    } else {
      return false;
    }
  }
};

export const validateTaxIDSSNCode = (inputText: any, len: any) => {
  if (len == 7) {
    var TaxIDSSN = /^\d{7}/;
    if (inputText.match(TaxIDSSN) && inputText.length == len) {
      return true;
    } else {
      return false;
    }
  }
};
export const validateOldPassword = (inputText: any, len: any) => {
  if (len >= 8) {
    var OldPassword =
      /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})/;
    if (inputText.match(OldPassword) && inputText.length >= len) {
      return true;
    } else {
      return false;
    }
  }
};

export const validateNewPassword = (inputText: any, len: any) => {
  let regex = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!#$%&?@*^]).{8,}$/

  if (regex.test(inputText) && inputText.length <= len) {
    return true;
  } else {
    return false;
  }
};

export const validateConfirmPassword = (password: string, confirmPassword: string) => {
  
  return password === confirmPassword;
};

export const validateContactNumber = (inputText: any, len: any) => {
  const regex = new RegExp(`^[0-9]{${len}}$`);
  inputText = inputText.toString();
  return regex.test(inputText);

  // if (len == 8) {
  //   var phoneNo = /^\d{8}/;
  //   if (inputText.match(phoneNo) && inputText.length == len) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }
  // if (len == 9) {
  //   var phoneNo = /^\d{9}/;
  //   if (inputText.match(phoneNo) && inputText.length == len) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }
  // if (len == 10) {
  //   // var phoneNo = /^[7-9][0-9]{9}$/;
  //   let phoneNo = /^[0-9]{10}$/;
  //   if (inputText.match(phoneNo) && inputText.length == len) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }
  // if (len == 11) {
  //   var phoneNo = /^\d{11}/;
  //   if (inputText.match(phoneNo) && inputText.length == len) {
  //     return false;
  //   } else {
  //     return true;
  //   }
  // }
  // if (len == 12) {
  //   var phoneNo = /^\d{12}/;
  //   if (inputText.match(phoneNo) && inputText.length == len) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }
};
export const validateIccId = (inputText: any) => {
  var iccId = /^\d{20}/;
  if (inputText.match(iccId) && inputText.length == 20) {
    return true;
  } else {
    return false;
  }
};
export const validateImeiNo = (inputText: any) => {
  var imeiNo = /^\d{15}/;
  if (inputText.match(imeiNo) && inputText.length == 15) {
    return true;
  } else {
    return false;
  }
};

export const validateMobileNo = (inputText: any) => {
  var phoneNo =
    /"^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$"/gim;
  if (inputText.match(phoneNo) && inputText.length == 10) {
    return true;
  } else {
    return false;
  }
};

export const validDocNumber = (inputText: any) => {
  if (!inputText) {
    return true;
  }
  const docNum = /^[a-z0-9]+$/i;
  if (inputText.match(docNum)) {
    return true;
  } else {
    return false;
  }
};

export const validPANNo = (inputText: any) => {
  const pan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
  if (inputText.match(pan)) {
    return true;
  } else {
    return false;
  }
};

export const validLatLong = (inputText: any) => {
  const latLong = /^-?([1-8]?[1-9]|[1-9]0)\.{0}\d{1,6}$/;
  if (inputText.match(latLong)) {
    return true;
  } else {
    return false;
  }
};



export const validGSTNo = (inputText: any) => {
  const gst = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  if (inputText.match(gst)) {
    return true;
  } else {
    return false;
  }
};

export const validWebsite = (inputText: any) => {
  const gst =
    /^(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?\/[a-zA-Z0-9]{2,}|((https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?)|(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?$/;
  // /^([a-zA-Z0-9_\-]+(?:\.[a-zA-Z0-9_\-]+)*\.[a-zA-Z]{2,4}(?:\/[a-zA-Z0-9_]+)*(?:\/[a-zA-Z0-9_]+\.[a-zA-Z]{2,4}(?:\?[a-zA-Z0-9_]+\=[a-zA-Z0-9_]+)?)?(?:\&[a-zA-Z0-9_]+\=[a-zA-Z0-9_]+)*)$/;
  if (inputText.match(gst)) {
    return true;
  } else {
    return false;
  }
};

export const validURLPath = (inputText: string) => {
  const regex = /^\/.*/

  if (inputText.match(regex)) {
    return true;
  } else {
    return false;
  }
};

export const validateAdharNo = (inputText: any) => {
  const adharNo = /^[2-9]{1}[0-9]{3}\s{1}[0-9]{4}\s{1}[0-9]{4}$/;
  if (inputText.match(adharNo)) {
    return true;
  } else {
    return false;
  }
};
export const validvoterNo = (inputText: any) => {
  const voter = /^([a-zA-Z]){3}([0-9]){7}?$/;
  if (inputText.match(voter)) {
    return true;
  } else {
    return false;
  }
};

export const validString = (inputText: any) => {
  const string = /^[a-zA-Z]*$/;
  if (inputText.match(string)) {
    return true;
  } else {
    return false;
  }
};

export const alphaNumeric = (inputText: any) => {
  const alpha = /^[a-zA-Z0-9 ]+$/;
  if (inputText.match(alpha)) {
    return true;
  } else {
    return false;
  }
};

export const alphabet = (inputText: any) => {
  const alpha = /^[a-zA-Z ]*$/;
  if (inputText.match(alpha)) {
    return true;
  } else {
    return false;
  }
};

export const validAnnualRevenue = (inputText: any) => {
  const alpha = /^\d+(\.\d{1,2})?$/;
  if (inputText?.match(alpha)) {
    return true;
  } else {
    return false;
  }
};

export const validateRegestrationNo = (inputTex: any) => {
  const no = /\b[(A-H|J-N|P|R-Z|0-9)]{5}\b/;
  if (inputTex.match(no)) {
    return true;
  } else {
    return false;
  }
};

export const ValidateVINNumber = (inputText: any) => {
  const no = /\b[(A-H|J-N|P|R-Z|0-9)]{17}\b/;
  if (inputText.match(no)) {
    return true;
  } else {
    return false;
  }
};

export const formateAdharNumber = (value: any) => {
  const updatedValue = value.replaceAll(" ", "");
  let newValue = "";
  for (let i = 0; i < updatedValue.length; i++) {
    if (i == 3 || i == 7) {
      newValue += updatedValue.charAt(i) + " ";
    } else {
      newValue += updatedValue.charAt(i);
    }
  }
  return newValue;
};

export const productNameStringManupelation = (displayName: any) => {
  let name = displayName.spli(",");
  name = name
    ?.map((el: any) => el?.replaceAll(" -", "")?.replaceAll("  ", " "))
    ?.join("")
    ?.replaceAll(" ", "-");
  return name;
};

export const validStringWithNoSpace = (inputText: any) => {
  const string = /^\S*$/;
  if (inputText?.match(string)) {
    return true;
  } else {
    return false;
  }
};

export const validationForNumber = (inputText: any, maxLength: number = 100) => {
  const alpha = /^[0-9]+$/;
  inputText = inputText?.toString()
  if (inputText?.match(alpha) && inputText?.length <= maxLength) {
    return true;
  } else {
    return false;
  }
};

export const ValidatefordecimalNumber = (inputTex: any) => {
  const no = /^\d*\.?\d*$/;
  if (inputTex?.match(no)) {
    return true;
  } else {
    return false;
  }
};

export const ValidationForDescription = (inputText: any) => {
  const alpha = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_=+-]).{4,12}$/;
  if (inputText.match(alpha)) {
    return true;
  } else {
    return false;
  }
};

export const validateBoolean = (value: any) => {
  return (typeof value) === 'boolean'
};